import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Button, Section, SubSection } from 'shared/services/parameter/parameter.service';
import { ThemeService } from 'shared/services/parameter/theme.service';

export interface PreviewDialogData {
  sections: Section[];
  imagePreviews: Record<string, string>;
}
@Component({
  selector: 'app-section-preview',
  templateUrl: './section-preview.component.html',
  styleUrls: ['./section-preview.component.scss']
})
export class SectionPreviewComponent implements OnInit {
  @Input() sections: Section[] = [];
  @Output() buttonClick = new EventEmitter<{ button: Button; section: SubSection }>();
  
  colors: any[] = [];
  constructor(private sanitizer: DomSanitizer,private themeService:ThemeService) {}

  ngOnInit(): void {
    this.themeService.parameter$.subscribe(param => {
      if (!param) return;

      
      this.colors = param.colors;
            const desiredOrder = [
              '--primary-color',
              '--standard-color',
              '--secondary-standard-color',
              '--primary-button-color'
            ];

            this.colors = param.colors
              .filter(c => desiredOrder.includes(c.variable))
              .sort((a, b) => desiredOrder.indexOf(a.variable) - desiredOrder.indexOf(b.variable));


      this.sections.forEach(section => {
        section.rows?.forEach(row => {
          row.subSections?.sort((a, b) => a.orderIndex - b.orderIndex);
        });
      });
    });
  }


  getFormattedHtml(content: string): SafeHtml {
    let html = content
      .replace(/\n/g, '<br>')
      .replace(/<b>/g, '<strong>')
      .replace(/<\/b>/g, '</strong>')
      .replace(/<i>/g, '<em>')
      .replace(/<\/i>/g, '</em>')
      .replace(/<u>/g, '<u>')
      .replace(/<\/u>/g, '</u>');

    this.colors.forEach((color, index) => {
      const openTag = new RegExp(`<color${index}>`, 'g');
      const closeTag = new RegExp(`</color${index}>`, 'g');
      html = html.replace(openTag, `<span style="color: ${color.value};">`);
      html = html.replace(closeTag, '</span>');
    });

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  getPrimaryColor(): string {
    const primaryColor = this.colors.find(c => c.variable === '--primary-color');
    return primaryColor?.value || '#D50000';
  }

  getPrimaryButtonColor(): string {
    const primaryButtonColor = this.colors.find(c => c.variable === '--primary-button-color');
    return primaryButtonColor?.value || '#D50000';
  }

  getPreviewGridColumnSpan(widthSpan: number): number {
    if (widthSpan === 3) return 6;
    if (widthSpan === 2) return 4;
    if (widthSpan === 1.5) return 3;
    return 2;
  }
  onButtonClick(button: Button, section: SubSection) {
    console.log('Clicked button:', button.label);
    console.log('Belongs to section:', section.title);

    this.buttonClick.emit({ button, section });
  }
}
